import { useState, useEffect, useCallback } from 'react';

const isEqual = (
  a: Readonly<GeolocationCoordinates>,
  b: Readonly<GeolocationCoordinates>,
) =>
  a.latitude === b.latitude &&
  a.longitude === b.longitude &&
  a.altitude === b.altitude;

// https://dev.to/trekhleb/creating-react-useposition-hook-for-getting-browser-s-geolocation-jdi
export const useGeolocation = () => {
  const [position, setPosition] = useState<GeolocationCoordinates>();
  const [error, setError] = useState<string>();

  const onChange = useCallback(
    ({ coords }: Readonly<GeolocationPosition>) => {
      if (position && isEqual(coords, position)) {
        return;
      }
      setPosition(coords);
    },
    [position],
  );

  const onError = useCallback((error: unknown) => {
    if (typeof error === 'string') {
      setError(error);
      return;
    } else if (error instanceof GeolocationPositionError) {
      setError(error.message);
      return;
    } else if (error instanceof Error) {
      setError(error.message);
      return;
    } else if (error instanceof Object) {
      setError(JSON.stringify(error));
      return;
    }
    setError('Unknown error');
    return;
  }, []);

  useEffect(() => {
    const geo = navigator.geolocation;
    const watcher = geo.watchPosition(onChange, onError);
    return () => {
      geo.clearWatch(watcher);
    };
  }, [onChange, onError]);

  return { position, error };
};
